import "./Header.css";
import { AiFillLinkedin,AiFillGithub, AiOutlineWhatsApp } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect} from 'react';
import PortfolioContext from "../context/PortfolioContext";
import { BsLightbulb , BsLightbulbOff} from "react-icons/bs";

function Header() {
  const navigate = useNavigate();
  const { setDarkTheme,darkTheme } = useContext(PortfolioContext);

  function handleClick() {
    navigate('/perfil');
  }

  function handleNavigateHome(){
    navigate('/');
  }
  
  function handleDarkMode() {
    setDarkTheme(!darkTheme);
  }

  return (
    <>
    <header className={darkTheme ? "header-dark":"header"}>
      <div className={darkTheme? "quem-sou-eu-dark" : "quem-sou-eu"}>
        <h1>VITOR SILVA .</h1>
        <button type="button" class={darkTheme ? "btn-toogle-dark" : "btn-toogle"} onClick={ handleDarkMode }>{ darkTheme ? <BsLightbulbOff size={30}/> : <BsLightbulb size={30} />}</button>
      </div>
      <div>
          <button type="button" class={ darkTheme ? "button-navigation-dark" : "button-navigation"} onClick={ handleClick }>Quem sou eu</button>
          <button type="button" class={ darkTheme ? "button-navigation-dark" : "button-navigation"}  onClick={ handleNavigateHome}>Início</button>
        </div>
      <ul className="ul-contatos">
        <li>
          <a className="dark-icon"  href="https://www.linkedin.com/in/vitor-oliveira-silva-dev/"><AiFillLinkedin size={60}/></a>
        </li>
        <li>
          <a className="dark-icon" href="https://github.com/vitorSilva95"><AiFillGithub size={60}/></a>
        </li>
        <li>
          <a className="dark-icon" href="https://web.whatsapp.com/send?phone=5531999325928" target="blank"><AiOutlineWhatsApp size={60} /></a>
        </li>
      </ul>
      <div className="full-menu-hamburguer">
        <input id="menu-hamburguer"type="checkbox" />
        <label htmlFor="menu-hamburguer">
          <div className="menu">
            <span className="hamburguer"></span>
          </div>
        </label>
        <ul className="ul-menu">
        <li><a className="link-menu" href="/">Inicio</a> </li>
        <li><a className="link-menu" href="/perfil">Quem sou eu?</a></li>
        <li><a className="link-menu" href="/">Contato</a></li>
      </ul>
      </div>
    </header>
    </>
  )
}

export default Header;